// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"c551d8cb","21":"4c3f5a18","46":"655f4b08","375":"fda6f7f4","455":"89d33f27","488":"328ec08b","575":"0c82f86a","596":"0859f929","716":"334c775e","768":"42045b21","977":"e05582e0"}[chunkId] + ".chunk.js";
};